/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlCustomDomainResponse } from './ControlCustomDomainResponse';
import {
    ControlCustomDomainResponseFromJSON,
    ControlCustomDomainResponseFromJSONTyped,
    ControlCustomDomainResponseToJSON,
} from './ControlCustomDomainResponse';

/**
 * 
 * @export
 * @interface ControlPaginagedCustomDomainResponse
 */
export interface ControlPaginagedCustomDomainResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginagedCustomDomainResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginagedCustomDomainResponse
     */
    page_size: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginagedCustomDomainResponse
     */
    total: number;
    /**
     * 
     * @type {Array<ControlCustomDomainResponse>}
     * @memberof ControlPaginagedCustomDomainResponse
     */
    results: Array<ControlCustomDomainResponse>;
}

/**
 * Check if a given object implements the ControlPaginagedCustomDomainResponse interface.
 */
export function instanceOfControlPaginagedCustomDomainResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "page_size" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ControlPaginagedCustomDomainResponseFromJSON(json: any): ControlPaginagedCustomDomainResponse {
    return ControlPaginagedCustomDomainResponseFromJSONTyped(json, false);
}

export function ControlPaginagedCustomDomainResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginagedCustomDomainResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'page_size': json['page_size'],
        'total': json['total'],
        'results': ((json['results'] as Array<any>).map(ControlCustomDomainResponseFromJSON)),
    };
}

export function ControlPaginagedCustomDomainResponseToJSON(value?: ControlPaginagedCustomDomainResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'total': value.total,
        'results': ((value.results as Array<any>).map(ControlCustomDomainResponseToJSON)),
    };
}

